var React = require('react');

function MemoryMatchCardBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M185 612q-21 0 -30 -9.5t-9 -36.5q0 -50 7.5 -81.5t20.5 -50.5t26 -32q14 -14 32 -29t35 -33t28.5 -41.5t11.5 -54.5q0 -48 -31 -74.5t-85 -26.5q-35 0 -54.5 9t-30.5 21.5t-20 22t-23 9.5q-13 0 -27 -10.5t-14 -30.5q0 -21 20.5 -45t59.5 -40.5t93 -16.5 q63 0 107.5 22.5t68.5 61.5t24 88q0 42 -15 74.5t-35.5 58t-41 43.5t-33.5 31q-21 19 -30 39.5t-11 44.5t-2 56q0 12 -9 21.5t-33 9.5zM186 806q-26 0 -43 -18t-17 -42q0 -25 17.5 -42.5t42.5 -17.5q24 0 41.5 17.5t17.5 42.5q0 24 -17 42t-42 18z"}));
}

MemoryMatchCardBack.defaultProps = {"version":"1.1","viewBox":"22 62 373 744"};

module.exports = MemoryMatchCardBack;

MemoryMatchCardBack.default = MemoryMatchCardBack;
